import version from "../utils/version";

const PRODUCTION = process.env.PRODUCTION === "true";
const ENVIRONMENT = process.env.ENVIRONMENT;
const WhatsappQRAddress = {
    production: "https://api.supsis.live/api/whatsapp/qr",
    stage: "https://beta-api.supsis.live/api/whatsapp/qr",
    development: "http://tablet-api-local.supsis.live/api/whatsapp/qr",
    dev: "http://tablet-api-local.supsis.live/api/whatsapp/qr",
};
const WhatsappSnapshotAddress = {
    production: "https://api.supsis.live/api/whatsapp/ss",
    stage: "https://beta-api.supsis.live/api/whatsapp/ss",
    development: "http://tablet-api-local.supsis.live/api/whatsapp/ss",
    dev: "http://tablet-api-local.supsis.live/api/whatsapp/ss",
};
const WhatsappAvatarAddress = {
    production: "https://api.supsis.live/api/whatsapp/wp-avatar",
    stage: "https://beta-api.supsis.live/api/whatsapp/wp-avatar",
    development: "http://tablet-api-local.supsis.live/api/whatsapp/wp-avatar",
    dev: "http://tablet-api-local.supsis.live/api/whatsapp/wp-avatar",
};
const CONFIG = {
    PRODUCTION,
    ENVIRONMENT,
    SOCKET_URL: process.env.SOCKET_URL,
    IS_STAGE: process.env.ENVIRONMENT === "stage",
    IS_DEVELOPMENT: process.env.ENVIRONMENT === "development",
    VERSION: version,
    WEB_PUSH: {
        APP_SYNC_API_KEY: "da2-xzpo6dhcejfjhab3kpmydqmciu",
        APP_SYNC_URL: "https://ipj5j7mrcnfnrhmxgcbdv2yuiy.appsync-api.us-east-1.amazonaws.com/graphql",
        // VAPID_KEYS: VAPIDKeyStorage.getVapidKeys(),
        applicationServerKey: "BH860EdAPR_2Hwi1hc1V5Cc8tngWkjxpGOLhNR2D9jKJUFWhO2FQD5O6K10Uo_8Mu5W-WtfckH6bPju-wonJsMU",
    },
    WHATSAPP: {
        qrAddress: WhatsappQRAddress[ENVIRONMENT],
        snapshotAddress: WhatsappSnapshotAddress[ENVIRONMENT],
        avatarAddress: WhatsappAvatarAddress[ENVIRONMENT],
        LAUNCH_STATES: {
            NOT_CREATED: "NOT_CREATED",
            DEAD: "DEAD",
            QR_CODE_GENERATING: "QR_CODE_GENERATING",
            QR_CODE_GENERATED: "QR_CODE_GENERATED",
            AUTHENTICATING: "AUTHENTICATING",
            READY: "READY",
        },
    },
    SUPPORTED_LANGS: ["tr", "en", "ru"],
};
console.log("CONFIG", CONFIG);
export default CONFIG;
